export const Members = `EmploymentEquity/Committee/Members`;
export const SearchMembers = Members + '/Search';
export const Minutes = `EmploymentEquity/Committee/Minutes`;
export const SearchMinutes = Minutes + '/Search';